import {
    Grid,
} from "@material-ui/core";
import React, { useEffect, useState } from 'react'
import LeftControl from "../LeftControl";
import PageHeader from "../PageHeader";
import HardwareTable from "../TableComponents/hardware.table";
import { Form, Input, Modal, Select, DatePicker, message } from 'antd';
import { seriliazeParams } from "../../helpers/seriliazeParams";
import services from "../../Services";
import { ActionDropdown } from "../TableComponents/constants";
import moment from "moment-timezone";
import { getHardwareAttribute } from "../../Services/hr";
import PageLayout from "../LayoutComponents/PageLayout";
import { haveAccessByRole } from "../../helpers";

const {
    employee,
    hr
} = services;

const HardwareManagement = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hardwareData, sethardwareData] = useState(null);
    const [hardwareTypes, sethardwareTypes] = useState(null);
    const [hardwareManufactures, sethardwareManufactures] = useState(null);
    const [editHardwareFlag, seteditHardwareFlag] = useState(false);
    const [addHardwareFlag, setaddHardwareFlag] = useState(false);
    const [employeeListing, setemployeeListing] = useState(null)
    const [AttributeData, setAttributeData] = useState(null)
    const [onFilter, setOnFilter] = useState(false)

    const userDetails = JSON.parse(localStorage.getItem("user_profile"))

    const [filterParams, setFilterParams] = useState({
        employeeId: null,
        type: null,
        status: null,
        attribute1: null
    })
    const [form] = Form.useForm()
    const [formItem] = Form.useForm()
    const showModal = (data) => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        let body = {
            ...values,
            PurchaseDate: moment(values?.PurchaseDate).format("YYYY-MM-DD")
        };

        try {
            const response = await hr.on_add_hardware(body);

            handleCancel();
            message.success("Hardware Added Successfully");
            form.resetFields()


        } catch (error) {
            message.destroy();
            if (error?.response?.status == 409) {
                message.error({
                    content: (
                        <div>
                            <strong>Duplicate Device:</strong>
                            <div>A device with this serial number already exists.</div>
                        </div>
                    ),
                    duration: 5,
                    closable: false, // This removes the "x" icon
                });
            } else {
                message.error();

            }
        }
    };



    const handleAssignedToChange = (e) => {
        setOnFilter(true)
        setFilterParams(prev => { return { ...prev, employeeId: e } })
    };
    const handleAttributeChange = (e) => {
        setOnFilter(true)
        setFilterParams(prev => { return { ...prev, attribute1: e } })
    };
    const handleTypeChange = (e) => {
        setOnFilter(true)
        setFilterParams(prev => { return { ...prev, type: e } })
    };
    const handleStatusChange = (e) => {
        setOnFilter(true)
        setFilterParams(prev => { return { ...prev, status: e } })
    };


    const fetchHardwareData = async () => {
        if (!filterParams.employeeId) delete filterParams.employeeId
        if (!filterParams.type) delete filterParams.type
        if (!filterParams.status) delete filterParams.status
        if (!filterParams.attribute1) delete filterParams.attribute1
        let params = '?'.concat(seriliazeParams(filterParams))
        if (filterParams?.employeeId || filterParams?.status || filterParams?.type || filterParams?.attribute1) {
            const response = await employee.get_hardware_assignments(params)
            sethardwareData(response?.data?.rows)
            return
        }
        let response = await employee.get_hardware_assignments()
        sethardwareData(response?.data?.rows)
    }

    const fetchHardwareTypes = async () => {
        let hardwareTypes = await hr?.getHardwareType()
        sethardwareTypes(hardwareTypes?.data?.rows?.map(type => {
            return {
                value: type?.id,
                label: type?.EquipType
            }
        }))
    }

    const fetchHardwareManufactures = async () => {
        let response = await hr?.getHardwareName()
        sethardwareManufactures(response?.data?.rows?.map(manufacture => {
            return {
                value: manufacture?.id,
                label: manufacture?.title
            }
        }))
    }
    const fetchUserLisitng = async () => {
        let response = await employee.get_employee_listing_not_Terminated()
        let list = response?.data?.map(user => ({
            value: user?.id,
            label: user?.firstName + " " + user?.lastName
        }))
        setemployeeListing(prev => prev = list)
    }


    const onReset = () => {
        formItem.resetFields()
        setFilterParams({
            employeeId: null,
            type: null,
            status: null,
            attribute: null
        })
        setOnFilter(false)
    }
    // getHardwareAttribute
    const getAttributeData = async () => {
        const result = await getHardwareAttribute()
        if (result?.httpStatus === 200) {
            setAttributeData(result?.data)
        }
    }

    useEffect(() => {
        getAttributeData()
        fetchHardwareData()
        fetchHardwareTypes()
        fetchUserLisitng()
        fetchHardwareManufactures()
    }, [filterParams, editHardwareFlag, addHardwareFlag])

    return (
        <PageLayout>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">{`Hardware Management`}</Grid>
                {/* Page Start */}
                <div className="hardware_container">
                    <div className="hardware_filter_bar">
                        <div>
                            <Grid xs={4}>
                                {haveAccessByRole([2, 3, 8], "array") && <button style={{ border: "none", cursor: "pointer", backgroundColor: "#2963AD", color: "white", padding: "10px 15px", textAlign: "center", fontSize: "13px", borderRadius: "6px" }} onClick={showModal}>Add New Hardware</button>}
                                <Modal title="Add New Hardware Assignment" width={"50%"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={false}>
                                    <Grid xs={12}>
                                        <Form onFinish={onFinish} className="hardware_form" form={form}>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "5px", justifyContent: "space-evenly" }}>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                       <span>Type</span>
                                                    <Form.Item name={"type"} rules={[{ required: true, message: "" }]}>
                                                        <Select
                                                            showSearch
                                                            optionFilterProp="label"
                                                            style={{
                                                                width: 200,
                                                                borderRadius: "10px"
                                                            }}
                                                            options={hardwareTypes}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                    <span>Manufacturer</span>
                                                    <Form.Item name={"manufacture"} rules={[{ required: true, message: "" }]}>
                                                        <Select
                                                            showSearch
                                                            optionFilterProp="label"
                                                            style={{
                                                                width: 200,
                                                                borderRadius: "10px"
                                                            }}
                                                            options={hardwareManufactures}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                    <span>Model Number</span>
                                                    <Form.Item name={"ModelNbr"} rules={[{ required: true, message: "" }]}>
                                                        <Input
                                                            style={{
                                                                width: 200,
                                                                borderRadius: "10px"
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                    <span>Serial Number</span>
                                                    <Form.Item name={"HwSerialNbr"} rules={[{ required: true, message: "" }]}>
                                                        <Input
                                                            style={{
                                                                width: 200,
                                                                borderRadius: "10px"
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                    <span>Purchase Date</span>
                                                    <Form.Item name={"PurchaseDate"} rules={[{ required: true, message: "" }]}>
                                                        <DatePicker style={{ width: 200 }} />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                    <span>Attribute 1</span>
                                                    <Form.Item name={"Attribute1MacAddress"} rules={[{ required: true, message: "" }]}>
                                                        <Input
                                                            style={{
                                                                width: 200,
                                                                borderRadius: "10px"
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ justifyItems: "center", gridTemplateColumns: "35% 65%", display: "grid", alignItems: "center", textAlign: "center" }}>
                                                    <span>Attribute 2</span>
                                                    <Form.Item name={"Attribute2"} rules={[{ required: false, message: "" }]}>
                                                        <Input
                                                            style={{
                                                                width: 200,
                                                                borderRadius: "10px"
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                                    <Grid xs={4} style={{ display: "flex", justifyContent: "center" }} >
                                                        <button style={{ border: "none", cursor: "pointer", backgroundColor: "#2963AD", color: "white", padding: "8px 10px", textAlign: "center", fontSize: "13px", borderRadius: "6px" }} htmlType="submit" >Add Hardware</button>
                                                    </Grid>
                                                </div>
                                            </div>
                                        </Form>
                                    </Grid>
                                </Modal>
                            </Grid>
                        </div>
                        <div className="column-2">

                            <Grid xs={12} className="filter_box">
                                <Form form={formItem} className="hardware_form" >
                                    <div className="head">Filter</div>
                                    <div className="inputs">
                                        <span className="head">Assigned To</span>
                                        <Form.Item name="assignedTo">
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                filterOption={true}
                                                style={{
                                                    width: 200,
                                                    borderRadius: "10px"
                                                }}
                                                onChange={handleAssignedToChange}
                                                options={employeeListing}
                                            />
                                        </Form.Item>
                                    </div>
                                    {/* Attribute Filter ----------> */}
                                    <div className="inputs">
                                        <span className="head">Attribute</span>
                                        <Form.Item name="attribute">
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                filterOption={true}
                                                style={{
                                                    width: 200,
                                                    borderRadius: "10px"
                                                }}
                                                onChange={handleAttributeChange}
                                                options={AttributeData}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="inputs">
                                        <span className="head">Type</span>
                                        <Form.Item name="type">
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                style={{
                                                    width: 200,
                                                    borderRadius: "10px"
                                                }}
                                                onChange={handleTypeChange}
                                                options={hardwareTypes}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="inputs">
                                        <span className="head">Status</span>
                                        <Form.Item name="status">
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                style={{
                                                    width: 200,
                                                    borderRadius: "10px"
                                                }}
                                                onChange={handleStatusChange}
                                                options={ActionDropdown}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                                        <button onClick={() => onReset()} style={{ fontSize: "12px" }}>Reset Filter</button>
                                    </div>
                                </Form>
                            </Grid>
                        </div>
                    </div>
                    <Grid xs={12}>
                        <HardwareTable data={hardwareData} typeListing={hardwareTypes} userListing={employeeListing} editFlag={seteditHardwareFlag} onFilter={onFilter} />
                    </Grid>
                </div>
            </Grid>
        </PageLayout>
    )
}

export default HardwareManagement